import { CSSProperties, ChangeEvent, FC } from 'react';
import { Switch, styled } from '@mui/material';
import Text from '../Text';
import { PEARL, PRIMARY } from '../../Helpers/colors';
import { InputBackgroundType, backgroundColors } from '../Input';

interface SwitchProperties {
	backgroundType?: InputBackgroundType;
	checked: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	label: string;
	labelPlacement?: 'left' | 'right';
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	style?: CSSProperties;
}

const CustomizedSwitch = styled(Switch)(({ disabled }) => ({
	width: 44,
	height: 24,
	padding: 0,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 2,
		transitionDuration: '300ms',
		'&.Mui-checked': {
			transform: 'translateX(20px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				backgroundColor: disabled ? PEARL.TERTIARY : PRIMARY.BASE,
				opacity: 1,
				border: 0,
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.5,
			},
		},
		'&.Mui-focusVisible .MuiSwitch-thumb': {
			color: PRIMARY.BASE,
			border: '6px solid #fff',
		},
		'&.Mui-disabled .MuiSwitch-thumb': {
			color: PEARL.BASE[300],
		},
		'&.Mui-disabled + .MuiSwitch-track': {
			opacity: 0.7,
		},
	},
	'& .MuiSwitch-thumb': {
		boxSizing: 'border-box',
		width: 20,
		height: 20,
		backgroundColor: disabled ? PEARL.BASE[300] : '#fff',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
	},
	'& .MuiSwitch-track': {
		borderRadius: 24 / 2,
		backgroundColor: disabled ? PEARL.TERTIARY : PEARL.BASE[200],
		opacity: 1,
		transition: 'background-color 300ms',
	},
}));

const CustomSwitch: FC<SwitchProperties> = ({
	label,
	checked,
	onChange,
	disabled = false,
	style = {},
	labelPlacement = 'left',
	backgroundType = 'primary',
	fullWidth = false,
}) => (
	<div
		style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: fullWidth ? 'space-between' : undefined,
			gap: 8,
			backgroundColor: backgroundColors[backgroundType],
			padding: '10px 16px',
			borderRadius: '9px',
			width: fullWidth ? '100%' : undefined,
			...style,
		}}
	>
		{labelPlacement === 'left' && <Text title={label} type="psm" fontWeight="medium" />}
		<CustomizedSwitch checked={checked} onChange={onChange} disabled={disabled} />
		{labelPlacement === 'right' && <Text title={label} type="psm" fontWeight="medium" />}
	</div>
);

export default CustomSwitch;
